<template>
  <div class="s_chat_middle_emoji">
    <chat-middle-emoji-face v-for="(item,index) in emojis" :key="index" :text="item"  @emitEmojiClick="emitEmojiClick"/>
  </div>
</template>

<script>
import ChatMiddleEmojiFace from '@/views/chat/ChatMiddleEmojiFace.vue';
  export default {
    components:{
      ChatMiddleEmojiFace,
    },
    data() {
      return {
         emojis: [
          "angry",
          "anguished",
          "astonished",
          "blush",
          "cold_sweat",
          "confounded",
          "confused",
          "cry",
          "disappointed",

          "disappointed_relieved",
          "dizzy_face",
          "expressionless",
          "fearful",
          "flushed",
          "frowning",
          "grimacing",
          "grin",
          "grinning",

          "heart_eyes",
          "hushed",
          "innocent",
          "joy",
          "kissing_closed_eyes",
          "kissing_heart",
          "laughing",
          "neutral_face",
          "no_mouth",

          "open_mouth",
          "pensive",
          "persevere",
          "relaxed",
          "relieved",
          "sleepy",
          "smile",
          "smiley",
          "smirk",

          "sob",
          "stuck_out_tongue",
          "sunglasses",
          "sweat",
          "sweat_smile",
          "scream",
          "wink",
          "unamused",
          "satisfied",
          
          "worried",
          "stuck_out_tongue_closed_eyes",
          "weary",
          "yum",
          "tired_face",
          "triumph",
          "stuck_out_tongue_winking_eye"
        ]
      }
    },
    methods: {
      emitEmojiClick(a) {
        this.$emit("emitEmojiSelect", a);
      }
    }
  }
</script>

<style lang="scss">
.s_chat_middle_emoji{
  text-align: left;
  background-color: #ffffff;
  position: absolute;
  width: $EmojiWidth;
  top: -12px;
  left: 50%;
  z-index: 999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  transform:translateX(-50%) translateY(-100%);
  &::before {
    content: "";
    position: absolute;
    border-top: 8px solid $white;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    bottom: 1px;
    left: 50%;
    transform: translateX(-50%) translateY(100%);
  }
}
</style>